<lib-dialog
  [title]="'Account is already existed'"
  [displayActionContainerAsColumnOnMobile]="true"
  (closeButtonClick)="closeDialog()"
>
  <div body>
    <h3 *ngIf="!isEmailExists && !isPhoneNrExists">
      {{ 'account-existed-dialog.text.title' | translate : { email, phoneNr } }}
    </h3>
    <h3 *ngIf="isEmailExists">
      {{
        'account-existed-dialog.text.title-email-exists' | translate : { email }
      }}
    </h3>
    <h3 *ngIf="isPhoneNrExists && !isEmailExists">
      {{
        'account-existed-dialog.text.title-phone-exists'
          | translate : { phoneNr }
      }}
    </h3>

    <lib-info-box>
      <span *ngIf="!isEmailExists && !isPhoneNrExists">{{
        'account-existed-dialog.text.hint' | translate
      }}</span>
      <span *ngIf="isEmailExists">{{
        'account-existed-dialog.text.hint-email-exists' | translate
      }}</span>
      <span *ngIf="isPhoneNrExists && !isEmailExists">{{
        'account-existed-dialog.text.hint-phone-exists' | translate
      }}</span>
    </lib-info-box>
  </div>

  <ng-container action>
    <button mat-stroked-button color="primary" (click)="closeDialog()">
      {{ 'account-existed-dialog.buttons.cancel' | translate }}
    </button>
    <button mat-flat-button color="primary" (click)="navigateToLogin()">
      {{ 'account-existed-dialog.buttons.login' | translate }}
    </button>
  </ng-container>
</lib-dialog>
